<h2 mat-dialog-title>Send {{ data.reportName }}</h2>

<mat-dialog-content class="dialog-content">
  <p class="helper">
    This sends the report once to the email address below and does not use saved report recipients.
  </p>

  <form [formGroup]="form">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Email address</mat-label>
      <input matInput type="email" formControlName="email" />
      @if (form.get('email')?.hasError('required')) {
        <mat-error>Email address is required.</mat-error>
      }
      @if (form.get('email')?.hasError('email')) {
        <mat-error>Enter a valid email address.</mat-error>
      }
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" type="button" (click)="submit()">Send report</button>
</mat-dialog-actions>
